import React from "react";
import { FormProvider, useForm } from "react-hook-form";

import { Button } from "components";
import { HookFormInputGroup } from "components/hookForms";
import { FormContainer, FormContent } from "components/layout";
import { ValidationMessages } from "globalConstants";
import { trimMidSentenceNormalizer, trimNormalizer } from "validators";

type UpdateWebsiteFormProps = {
	handleSave: Function;
};

export const UpdateWebsiteForm = ({ handleSave }: UpdateWebsiteFormProps) => {
	const formMethods = useForm({
		mode: "onBlur",
		reValidateMode: "onChange",
		shouldUnregister: false,
	});
	const {
		register,

		formState: { errors, isDirty },
		getValues,
	} = formMethods;

	return (
		<FormProvider {...formMethods}>
			<FormContent className="p-0">
				<FormContainer>
					<form>
						<HookFormInputGroup
							colInput={12}
							name="website"
							label="Website"
							blurLoading={false}
							register={register}
							errors={errors}
							normalize={trimMidSentenceNormalizer}
							normalizeOnBlur={trimNormalizer}
							disabled={false}
							warningText={ValidationMessages.WebsiteMessage}
						/>
						<div className="text-center mt-5">
							<Button
								onClick={() => handleSave(getValues())}
								value="Save"
								disabled={!isDirty}
							/>
						</div>
					</form>
				</FormContainer>
			</FormContent>
		</FormProvider>
	);
};
